// Die sechs Töne des Systems (README „Status“) und ihre Klassen.
// Jeder Ton steht als Text auf seiner -soft-Fläche oder auf card.

export type Tone = 'neutral' | 'info' | 'warning' | 'highlight' | 'success' | 'danger';

/** Text im Ton, Fläche in -soft. */
export const TONE_PILL: Record<Tone, string> = {
  neutral: 'bg-muted text-muted-foreground',
  info: 'bg-info-soft text-info',
  warning: 'bg-warning-soft text-warning',
  highlight: 'bg-highlight-soft text-highlight',
  success: 'bg-success-soft text-success',
  danger: 'bg-danger-soft text-danger',
};

/** Nur Text im Ton. */
export const TONE_TEXT: Record<Tone, string> = {
  neutral: 'text-muted-foreground',
  info: 'text-info',
  warning: 'text-warning',
  highlight: 'text-highlight',
  success: 'text-success',
  danger: 'text-danger',
};

/** Nur Fläche im Ton. */
export const TONE_SOFT: Record<Tone, string> = {
  neutral: 'bg-muted',
  info: 'bg-info-soft',
  warning: 'bg-warning-soft',
  highlight: 'bg-highlight-soft',
  success: 'bg-success-soft',
  danger: 'bg-danger-soft',
};
